export default __webpack_public_path__ + "static/media/gallery-wip-neck-ring_03.df54f9d0.jpg";